import { getSignupStepNumber } from './patients';

export const formatLeadStatus = (lead, {includeStep = false} = {}) => {
  const stepText = (
    lead.patient && includeStep
    ? ' (' + getSignupStepNumber(lead.patient, {includeStep: true}) + '/7)'
    : ''
  );
  switch (lead.status) {
    case 'ACTIVE':
      return 'Active';
    case 'NEW':
      return 'New Patient Lead';
    case 'CREATED_ACCOUNT':
      return `Signup Started ${stepText}`;
    case 'COMPLETED_SIGNUP':
      return `Signup Completed`;
    case 'SCHEDULED':
      return 'Eval Scheduled';
    case 'EVALUATED':
      return 'Eval Completed';
    case 'LOST':
      return 'Lost Lead';
    case 'ARCHIVED':
      return 'Archived';
    default:
      return 'Unknown!';
  }
};

export const getTouchpointOptions = () => ([            
  {value: 'PHONE', label: 'Call'},
  {value: 'TEXT', label: 'Text'},
  {value: 'EMAIL', label: 'Email'},
  {value: 'IN_PERSON', label: 'In Person'},
  {value: 'INTERNAL', label: 'Internal'},
  {value: 'OTHER', label: 'Other'},
]);